export enum WebsiteEndpoints {
    // ===== Auth =====
    LOGIN = 'auth/login/',
    REFRESH_TOKEN = 'auth/refresh/',
    FORGOT_PASSWORD = 'auth/forgot-password/',
    VERIFY_OTP = 'auth/verify-otp/',
    RESET_PASSWORD = 'auth/reset-password/',
    LOGOUT = 'auth/logout/',

    // ===== Users =====
    USERS = 'users/',
    USER_BRANDS = 'users/brands/',
    PROFILE = 'users/profile/',
    CHANGE_PASSWORD = 'users/profile/change-password/',

    // ===== Brands =====
    BRANDS = 'brands/',
    ORGANIZATIONS = 'organizations/',
    PLATFORMS = 'platforms/',
    CATEGORIES = 'categories/',
    COMPETITORS = 'competitors/',
    CONTACT = 'users/contact/',

    // ===== Analysis =====
    ADMIN_DASHBOARD = 'analysis/dashboard/',
    BRAND_DASHBOARD = 'analysis/brand-dashboard/',
    INSIGHTS = 'analysis/insights/',
    DASHBOARD_POSITIVE = 'analysis/dashboard-positive/',
    CRO_BARRIERS = 'analysis/cro-barriers/',
    INCENTIVE_INSIGHTS = 'analysis/incentive-insights/',
    PLP_INSIGHTS = 'analysis/plp-insights/',
    PDP_INSIGHTS = 'analysis/pdp-insights/',
    REVIEWS_INSIGHTS = 'analysis/reviews-insights/',
    CATEGORY_VIEW = 'analysis/category/',
    BRAND_AUDIT = 'analysis/brand-audit/',
    PRODUCT_CATALOG = 'analysis/product-catalog/',
    CATALOG_DETAIL = 'analysis/catalog-detail/',
    REPORTS = 'analysis/reports/',
    CONTENT_INSIGHTS = 'analysis/content-insights/',
    QCOMMERCE_REPORTS = 'analysis/qcommerce-reports/',
    GENERATE_CONTENT = 'analysis/generate-content/',
    UPDATE_PRODUCT_CONTENT = 'analysis/update-product-content/',

    GEN_INSIGHTS_REGENERATE = 'scheduler/gen-insights/regenerate',
    GEN_INSIGHTS_GRAPH = 'scheduler/gen-insights/brand-graph',
    GEN_INSIGHTS_RISK = 'scheduler/gen-insights/risk',
    GEN_INSIGHTS_POSITIVE = 'scheduler/gen-insights/positive',
    GEN_INSIGHTS_REVIEWS = 'scheduler/gen-insights/reviews',
    GEN_INSIGHTS_PLP = 'scheduler/gen-insights/plp',
    GEN_INSIGHTS_PDP = 'scheduler/gen-insights/pdp',
    GEN_INSIGHTS_INCENTIVE = 'scheduler/gen-insights/incentive',

    // ===== Scheduler / JSON Builder =====
    SCHEDULERS = 'scheduler/schedulers/',
    SCHEDULER_TASKS = 'scheduler/tasks/',
    SCHEDULER_JOBS = 'scheduler/jobs/',

    // ===== Data Dump / Keywords =====
    DATA_DUMP = 'scheduler/data-dump/',
    JSON_BUILDER = 'scheduler/json-builder/',
}
